// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b75d7a3","239":"fac07702","732":"fe1b1f7f"}[chunkId] + ".chunk.js";
};